<template>
  <div class="store">
    <h1>Store</h1>
  </div>
</template>
